

// "use client";

// import React, { useEffect, useRef, useState } from "react";
// import { motion, useAnimation } from "framer-motion";
// import TaskAltIcon from "@mui/icons-material/TaskAlt";

// function HistorySection() {
//   const controls = useAnimation();
//   const sectionRef = useRef<HTMLDivElement>(null);
//   const [prevY, setPrevY] = useState(0);

//   useEffect(() => {
//     const observer = new IntersectionObserver(
//       ([entry]) => {
//         const currentY = entry.boundingClientRect.y;

//         if (entry.isIntersecting && currentY > prevY) {
//           controls.start("visible");
//         }
//         setPrevY(currentY);
//       },
//       { threshold: 0.2 }
//     );

//     if (sectionRef.current) {
//       observer.observe(sectionRef.current);
//     }

//     return () => {
//       if (sectionRef.current) {
//         observer.unobserve(sectionRef.current);
//       }
//     };
//   }, [controls, prevY]);

//   const variants = {
//     hiddenLeft: { opacity: 0, x: -100 },
//     hiddenRight: { opacity: 0, x: 100 },
//     visible: {
//       opacity: 1,
//       x: 0,
//       transition: { duration: 1, ease: "easeOut" },
//     },
//   };

//   return (
//     <div
//       ref={sectionRef}
//       className="bg-[#2D3A45] py-10 relative lg:py-5 lg:pb-28"
//     >
//       <div className="absolute left-0 right-0 bg-gradient-to-t -top-28 w-full min-h-28 z-20 from-[#2D3A45] to-transparent"></div>

//       <h4 className="text-white text-2xl font-normal px-4 pt-6 lg:hidden">
//         Our History
//       </h4>
//       <div className="border-b border-b-gray-700 mx-4 my-3 lg:hidden"></div>

//       <h4 className="text-white hidden lg:block text-2xl font-normal lg:pl-[137px] pt-10">
//         Our History
//       </h4>
//       <div className="border-b hidden lg:block border-b-gray-700 mx-32 my-5"></div>

//       <p className="max-w-7xl mx-auto text-white text-[18px] lg:text-[20px] px-4  leading-relaxed">
//         Siskon Venture PVT. LTD. was established in 2017, promoted by the owners of SISKON GROUP OF COMPANIES, with over 35 years of expertise in Core Hydraulics, Automation, and Filtration.
//       </p>

//       <div className="grid grid-cols-1 lg:grid-cols-6 mt-6 lg:overflow-hidden">
//         <motion.div
//           initial="hiddenLeft"
//           animate={controls}
//           variants={variants}
//           className="lg:col-span-3 flex justify-center lg:py-10 lg:px-5"
//         >
//           <div className="hidden lg:block">
//             <img
//               src="/assets/image/our_history.png"
//               alt="Hydraulic excavator arm against blue sky"
//               className="w-[70vh] h-[70vh] object-cover"
//             />
//           </div>

//           <div
//             className="w-full h-[50vh] lg:hidden bg-cover bg-center"
//             style={{ backgroundImage: "url('/assets/image/our_history.png')" }}
//           >
//           </div>
//         </motion.div>

//         <motion.div
//           initial="hiddenRight"
//           animate={controls}
//           variants={variants}
//           className="lg:col-span-3 px-4 lg:pr-40 text-white text-lg lg:text-[22px] mt-6 lg:mt-11"
//         >
//           <div className="flex flex-col gap-6 my-6 ">
//             {[
//               "Started Siskon Engineering Services (1995)",
//               "Hydraulic spares, systems, services",
//               "Power packs & manifold blocks manufacturing",
//               "Test benches supplied to Essar Steels & Apollo Tyres",
//               "Service support for Parker & Bondioli & Pavesi",
//               "Installation & commissioning of hydraulic systems",
//               "Consultancy & training in hydraulics",
//             ].map((text, index) => (
//               <div key={index} className="flex items-start gap-4">
//                 <TaskAltIcon className="mt-1" style={{ fontSize: "28px" }} />
//                 <span className="leading-loose">{text}</span>
//               </div>
//             ))}
//           </div>
//         </motion.div>
//       </div>
//     </div>
//   );
// }

// export default HistorySection;

"use client";

import React from "react";
import { motion, Variants } from "framer-motion";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import {globalTransition} from "../../../assets/animate/globalAnimation"


function HistorySection() {
  // Define variants matching the sample component
  const containerVariants: Variants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.3, // Matches sample component
        ...globalTransition
      },
    },
  };

  const childVariants: Variants = {
    hidden: { opacity: 0, x: -100 },
    visible: {
      opacity: 1,
      x: 0,
      transition: {...globalTransition, ease: "easeOut" }, // Matches sample
    },
  };

  const rightChildVariants: Variants = {
    hidden: { opacity: 0, x: 100 },
    visible: {
      opacity: 1,
      x: 0,
      transition: {...globalTransition, ease: "easeOut" }, // Matches sample
    },
  };

  const timeline = [
    {
      year: "1995",
      highlight: "Business Establishment",
      description:
        "Siskon Hydraulics was founded, marking the beginning of our journey in the hydraulic industry.",
    },
    {
      year: "2000",
      highlight: "First Major Hydraulic System Deployment",
      description:
        "Successfully designed and installed a large-scale hydraulic power unit for a Tire manufacturer, setting a benchmark for future projects.",
    },
    {
      year: "2005",
      highlight: "Expansion into Hydraulic Pump & Motor Servicing",
      description:
        "Introduced specialized services for repairing and maintaining hydraulic pumps and motors, enhancing customer support. Also acquired 150 sq. m. site in Vatva Gujarat.",
    },
    {
      year: "2010",
      highlight: "Advanced Filtration & Oil Monitoring Solutions",
      description:
        "Integrated oil monitoring systems from Parker Hydraulics, ensuring improved reliability and reduced failures in hydraulic systems.",
    },
    {
      year: "2017",
      highlight: "Established Siskon Ventures Pvt. Ltd",
      description: "",
    },
    {
      year: "2018",
      highlight: "Collaboration with Mining Industry OEM",
      description:
        "Partnered with leading manufacturers to provide customized hydraulic solutions for large-scale mining application.",
    },
    {
      year: "2020",
      highlight: "Development of High-Performance Power Units",
      description:
        "Designed and tested next-generation hydraulic power units, improving energy efficiency and system performance.",
    },
    {
      year: "2024",
      highlight: "Factory Expansion to 300 sq meters",
      description:
        "Expanded our facility to 300 sq meters, dedicating space for assembly, servicing, and testing of hydraulic power units.",
    },
    {
      year: "2025",
      highlight: "30 Years of Excellence in Hydraulics",
      description:
        "Celebrating three decades of delivering top-quality hydraulic solutions, innovation, and customer satisfaction.",
    },
  ];
  

  return (
    <div id="history-section" className="bg-[#2D3A45] py-10 relative lg:py-5 lg:pb-28">
      <div className="absolute left-0 right-0 bg-gradient-to-t -top-28 w-full min-h-28 z-20 from-[#2D3A45] to-transparent"></div>

      <h4 className="text-white text-2xl font-normal px-4 pt-6 lg:hidden">
        Our History
      </h4>
      <div className="border-b border-b-gray-700 mx-4 my-3 lg:hidden"></div>

      <h4 className="text-white hidden lg:block text-2xl font-normal lg:pl-[137px] pt-10">
        Our History
      </h4>
      <div className="border-b hidden lg:block border-b-gray-700 mx-32 my-5"></div>

      <p className="max-w-7xl mx-auto text-white text-[18px] lg:text-[20px] px-4 leading-relaxed">
        Siskon Venture PVT. LTD. was established in 2017, promoted by the owners of SISKON GROUP OF COMPANIES, with over 35 years of expertise in Core Hydraulics, Automation, and Filtration.
      </p>

      {/* Apply container variants */}
      <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.1 }} // Trigger when 10% is in view, like sample
        variants={containerVariants}
        className="grid grid-cols-1 lg:grid-cols-6 mt-6 lg:overflow-hidden"
      >
        <motion.div
          variants={childVariants} // Left animation
          className="lg:col-span-3 flex justify-center lg:py-10 lg:px-5"
        >
          <div className="hidden lg:block">
            <img
              src="/assets/image/history.png"
              alt="Hydraulic excavator arm against blue sky"
              className="w-[70vh] h-[70vh] object-cover"
            />
          </div>

          <div
            className="w-full h-[50vh] lg:hidden bg-cover bg-center"
            style={{ backgroundImage: "url('/assets/image/history.png')" }}
          ></div>
        </motion.div>

        <motion.div
          variants={rightChildVariants} // Right animation
          className="lg:col-span-3 px-4 lg:pr-40 text-white text-[18px] lg:text-[20px] mt-6"
        >
<div className="flex flex-col gap-6 my-6">
  {timeline.map((item, index) => (
    <div key={index} className="flex items-start gap-4">
      <TaskAltIcon className="mt-1" style={{ fontSize: "28px" }} />
      <div>
        <p className="font-bold">
          {item.year} - {item.highlight}
        </p>
        {item.description && (
          <p className="leading-relaxed">
            {item.description}
          </p>
        )}
      </div>
    </div>
  ))}
</div>
        </motion.div>
      </motion.div>
    </div>
  );
}

export default HistorySection;

